import React from 'react'
import utils from './utils'

let lastMatrix = {}

function getLevelLayout(width, height, settings, quantities, answer, newConfig = true) {
    return getLayout(width, height, settings, quantities, answer, newConfig)
}

function getLayout(width, height, settings, quantities, answer, newConfig) {
    const {
        gameContainerWidth,
        gameContainerHeight,
        lineWeight,
    } = getLayoutSettings(width, height)
    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}
        >
            {getFrame(quantities.value_1, lineWeight, lineWeight, gameContainerWidth, gameContainerHeight, lineWeight, settings, newConfig)}
        </svg>
    )
}
function getFrame(value_1, x, y, width, height, lineWeight, settings, newConfig) {
    let gridWidht =  settings.show_grid ? (settings['width'] || value_1) : value_1
    let gridHeight = settings.show_grid ? (settings['height'] || 1) : 1
    let colour = settings.colour || 'silver'
    let formMatrix = getMatrix(value_1, settings.form_matrix, !newConfig ? lastMatrix[value_1] : null)

    if (formMatrix) {
        gridWidht = getGridWidthFromMatrix(formMatrix)
        gridHeight = getGridHeightFromMatrix(formMatrix)
    }

    let size = 0
    //let maxSize = width / 10
    let sideOffset = lineWeight
    let topOffset = lineWeight

    let gridPath = ''
    let dots = []
    let gridLayout = null


    if (width / gridWidht > height / gridHeight) {
        size = (height - lineWeight * 2) / gridHeight
        //size = size > maxSize ? maxSize : size
        sideOffset = (width - size * gridWidht) / 2
        topOffset = (height - size * gridHeight) / 2

    } else {
        size = (width - lineWeight * 2) / gridWidht
        //size = size > maxSize ? maxSize : size
        sideOffset = (width - size * gridWidht) / 2
        topOffset = (height - size * gridHeight) / 2
    }
    let circleSize = size / 1.3

    if (settings.show_grid) {
        for (let i = 1; i < gridHeight; i++) {
            gridPath += `M ${sideOffset} ${topOffset + size * i} H ${sideOffset + size * gridWidht}`
        }

        for (let i = 1; i < gridWidht; i++) {
            gridPath += `M ${sideOffset + size * i} ${topOffset} V ${topOffset + size * gridHeight}`
        }

        gridLayout = (
            <g>
                <rect
                    x={sideOffset}
                    y={topOffset}
                    width={size * gridWidht}
                    height={size * gridHeight}
                    fill='none'
                    strokeWidth={lineWeight}
                    stroke="white"
                />
                <path
                    d={gridPath}
                    fill="none"
                    stroke="white"
                    strokeWidth={lineWeight}
                />
            </g>
        )
    }
    if (formMatrix) {

        for (let i = 1; i <= gridHeight; i++) {
            for (let j = 1; j <= gridWidht; j++) {
                if (formMatrix[i - 1] instanceof Array && formMatrix[i - 1].includes('' + j)) {
                    dots.push(
                        utils.getGear(sideOffset + size * j - size / 2, topOffset + size * i - size / 2, circleSize, colour)
                    )
                }
            }

        }
    } else {
        for (let i = 1; i <= gridHeight; i++) {
            for (let j = 1; j <= gridWidht; j++) {
                if (value_1 >= (j + (i - 1) * gridWidht)) {
                    dots.push(
                        utils.getGear(sideOffset + size * j - size / 2, topOffset + size * i - size / 2, circleSize, colour)
                    )
                }
            }

        }
    }

    return (
        <g>
            {gridLayout}
            {dots}
        </g>
    )

}

function getMatrix(value, matrixSettings, index = null) {
    if (matrixSettings && matrixSettings instanceof Object) {
        if (matrixSettings[value] instanceof Array) {
            let matrixIndex = index ? index : (!isNaN(lastMatrix[value]) ? lastMatrix[value] + 1 : 0)
            if(matrixIndex >= matrixSettings[value].length ){
                matrixIndex = 0
            }
            lastMatrix[value] = matrixIndex
            return matrixSettings[value][matrixIndex]
        }
    } 
    return null
}

function getGridWidthFromMatrix(martix) {
    let maxValue = 1
    martix.forEach(col => {
        col.forEach(val => {
            if (maxValue < val) {
                maxValue = val
            }
        });
    });
    return maxValue
}

function getGridHeightFromMatrix(martix) {
    return martix.length
}



function getLayoutSettings(gameContainerWidth, gameContainerHeight) {

    /* const gameContainerMargin = gameContainerWidth * .04
 
    if (gameContainerWidth * 0.6 > gameContainerHeight) {
        gameContainerWidth = gameContainerHeight / 0.6 - gameContainerMargin
        gameContainerHeight = gameContainerHeight - gameContainerMargin
    } else {
        gameContainerWidth = gameContainerWidth - gameContainerMargin
        gameContainerHeight = gameContainerWidth * 0.6 - gameContainerMargin
    } */

    const sideMargin = gameContainerWidth * .15
    const marginBottom = gameContainerWidth * .1
    const lineWeight = gameContainerWidth / 200
    const arrowSize = gameContainerWidth / 35
    const fontSize = gameContainerWidth / 15

    const gridCount = 5
    const rectWidth = gameContainerWidth - lineWeight * 2 - sideMargin * 2
    const rectHeight = rectWidth / gridCount * 2

    return {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        rectWidth,
        rectHeight,
        marginBottom,
        lineWeight,
        arrowSize,
        fontSize,
        gridCount
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/dots.utils.js